export interface ApiErrorResponse {
  error_code: string;
  message: string;
  details?: string;
}

export class ApiError extends Error {
  public readonly errorCode: string;
  public readonly statusCode: number;
  public readonly details?: string;

  constructor(
    message: string,
    errorCode: string,
    statusCode: number,
    details?: string
  ) {
    super(message);
    this.name = "ApiError";
    this.errorCode = errorCode;
    this.statusCode = statusCode;
    this.details = details;
  }

  static fromResponse(response: ApiErrorResponse, statusCode: number): ApiError {
    return new ApiError(
      response.message,
      response.error_code,
      statusCode,
      response.details
    );
  }
}
